import { FC } from 'react';
import styled from 'styled-components';
import { u } from '../common/Units';

interface AvatarProps {
  /** Name to take the initial from */
  name: string,
  /** Diameter in kiosk units */
  size?: number,
  className?: string
}

const Circle = styled.span<{ $size: number }>`
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: ${p => u(p.$size)};
  height: ${p => u(p.$size)};
  border-radius: 50%;
  background-color: ${p => p.theme.accentColor};
  color: #fff;
  font-size: ${p => u(p.$size * 0.42)};
  font-weight: 600;
  text-transform: uppercase;
`;

/**
 * Round badge with the initial of a name, in the accent color (e.g. the contributor of a Minne response)
 * @returns {JSX.Element|null} Component template
 */
const Avatar: FC<AvatarProps> = ({ name, size = 52, className }) => {
  const initial = name.trim().charAt(0);
  if (!initial) { return null; }
  return <Circle $size={size} className={className} aria-hidden="true">{initial}</Circle>;
}

export default Avatar;
